module.exports = __webpack_public_path__ + "img/finish-silver-mist.2f847792.jpg";